import React from "react";
import HoverIconButton from "components/HoverIconButton";
import CopyToClipboard from "components/CopyToClipboard";
import { getListBorders } from "utils/constants/ui";
import { getCopyPriceIdProps, getStripeFormattedAmount } from "utils/price";
import MonthlyIntervalShorthand from "components/MonthlyIntervalShorthand";
import Link from "next/link";
import { useRouter } from "next/router";
import { getPriceTaxBehaviorLabel } from "utils/taxRate";

const ProductPriceRow = ({ price, isFirst, isLast }) => {
  const containerProps = {
    className: getListBorders({
      className:
        "flex flex-column items-stretch b--black-20 bl br pointer user-select-n w-100",
      isFirst,
      isLast
    })
  };
  const taxBehavior = getPriceTaxBehaviorLabel(price);
  const hasFooter = price.nickname || taxBehavior;

  const formattedAmount = getStripeFormattedAmount(price);
  const { asPath } = useRouter();
  const showPricePath = `${asPath}/prices/${price.id}`;

  return (
    <div {...containerProps}>
      <div className="w-100 flex flex-row items-stretch justify-between">
        <div className="flex flex-row w-100 items-stretch">
          <div className="h-100 items-center flex br b--black-20">
            <CopyToClipboard {...getCopyPriceIdProps(price)} />
          </div>
          <Link href={showPricePath}>
            <div className="flex flex-row w-100 bg-white--hover">
              <div
                style={{ width: 52 }}
                className="h-100 items-center flex br b--black-20"
              >
                <div className="f7 ttu fw5 ph2">{price.currency}</div>
              </div>
              <div className="flex flex-row items-center w-100 justify-between">
                <div className="f5 fw5 pa2">{formattedAmount}</div>
                <MonthlyIntervalShorthand price={price} />
              </div>
            </div>
          </Link>
        </div>
        <Link href={showPricePath}>
          <div className="flex flex-row flex-shrink-0">
            <div className="h-100 items-center flex bl b--black-20">
              <HoverIconButton type="edit" tooltip="Edit" />
            </div>
          </div>
        </Link>
      </div>
      {hasFooter && (
        <div className="flex flex-row items-center w-100 justify-start bt hairline-1">
          {taxBehavior && <div className="f7 ph2 pv1">{taxBehavior}</div>}
          <div className="f7 ph2 pv1">{price.nickname}</div>
        </div>
      )}
    </div>
  );
};

export default ProductPriceRow;
